import { Paper, Tab, Tabs, Typography } from "@mui/material";
import { Box } from "@mui/system";
import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import AdvisorMaps from "./AdvisorMaps/AdvisorMaps";
import AdvisorGapRules from "./AdvisorGapRules/AdvisorGapRules";
import { resetAdvisorData } from "../../../features/advisorSlice";
import { selectUserData } from "../../../features/userSlice";
import { CheckPermissions } from "../../../logic/Admin/Permissions/CheckPermission/CheckPermissions";
import "./Advisor.css";

export const Advisor = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const dispatch = useDispatch();
  const userData = useSelector(selectUserData);

  useEffect(() => {
    return () => {
      dispatch(resetAdvisorData());
    };
  }, [dispatch]);

  const hasViewGapRulesPermission = CheckPermissions(
    userData?.data?.products?.data_collection,
    "businesse_advisor",
    "view_gap_rules",
  );

  const advisorTabs = [
    { id: 0, label: "Maps", disabled: false },
    { id: 1, label: "Gap Rules", disabled: !hasViewGapRulesPermission },
  ];

  const tabFromUrl = parseInt(searchParams.get("tab") ?? "", 10);
  // a disabled tab is never selectable, so a stale ?tab=1 falls back to Maps
  const selectedTab = advisorTabs.some(
    (tab) => tab.id === tabFromUrl && !tab.disabled,
  )
    ? tabFromUrl
    : 0;

  const handleChangeTab = (_: unknown, newValue: number) => {
    setSearchParams(
      (prevParams) => {
        const params = new URLSearchParams(prevParams);
        params.set("tab", String(newValue));
        return params;
      },
      { replace: true },
    );
  };

  return (
    <Paper elevation={0} sx={{ padding: "14px 16px" }}>
      <Typography variant="h3" sx={{ fontSize: "24px", mb: 1.5 }}>
        Advisor
      </Typography>
      <Box sx={{ borderBottom: 1, borderColor: "divider", mx: "-16px" }}>
        <Tabs
          className="advisorTabs"
          sx={{ pr: "16px" }}
          value={selectedTab}
          onChange={handleChangeTab}
          textColor="secondary"
          indicatorColor="secondary"
          aria-label="Advisor tabs"
        >
          {advisorTabs.map((tab) => (
            <Tab
              key={tab.id}
              label={tab.label}
              disabled={tab.disabled}
              id={`advisor-tab-${tab.id}`}
              aria-controls={`advisor-tabpanel-${tab.id}`}
            />
          ))}
        </Tabs>
      </Box>

      <div
        role="tabpanel"
        hidden={selectedTab !== 0}
        id="advisor-tabpanel-0"
        aria-labelledby="advisor-tab-0"
      >
        {selectedTab === 0 && <AdvisorMaps />}
      </div>

      <div
        role="tabpanel"
        hidden={selectedTab !== 1}
        id="advisor-tabpanel-1"
        aria-labelledby="advisor-tab-1"
      >
        {selectedTab === 1 && <AdvisorGapRules />}
      </div>
    </Paper>
  );
};
